import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

function getCurrentWayCode () {
  const payWay = wayCode.getPayWay()
  return payWay ? payWay.wayCode : null
}

/** 获取url **/
export function getRedirectUrl () {
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: getCurrentWayCode(), token: config.cacheToken }
  })
}

/** 获取url **/
export function getChannelUserId (redirectData) {
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: getCurrentWayCode(), token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount) {
  const currentWayCode = getCurrentWayCode()

  const data = {
    wayCode: currentWayCode,
    token: config.cacheToken,
    amount: amount
  }

  if (wayCode.requiresChannelUserId(currentWayCode)) {
    data.channelUserId = channelUserIdUtil.getChannelUserId()
  }

  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: data
  })
}

/** 模拟支付：调用后端demo接口生成订单 **/
export function createDemoOrder (data) {
  return request.request({
    url: '/api/anon/demoOrder',
    method: 'POST',
    data: data
  })
}


/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/api/cashier-home/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 获取应用支持的支付方式 **/
export function getPayWays () {
  return request.request({
    url: '/api/cashier-home/payways',
    method: 'GET',
    params: {
      token: config.cacheToken
    }
  })
}
